import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_basics.less'
import { getI18n, getI18nBase } from 'client/i18n'

import TipBox from 'components/common/tip_box'
import DateInputBox from 'components/common/date_input_box'
import MoneyTextBox from 'components/common/money_text_box'
import CharityCard from 'components/common/charity_card'

import TextBox from 'components/common/text_box'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import { CROWDFUNDING_CAMPAIGN_MAX_DAYS } from 'shared/shared_consts'
import { CaptionText, HeadingText } from '@paypalcorp/pp-react'
import { trackEventNameClick } from 'lib/fpti_analytics'

export const I18N_CONTEXT = 'components/pages/crowdfunding/pool_basics'

const i18n = getI18n(I18N_CONTEXT)
const i18nBase = getI18nBase(I18N_CONTEXT)

const getGoalAmountTitle = (charity, formattedMaxGoalAmount) => {
  if (charity) {
    return i18nBase('goal_amount_title_gnc')
  }
  return i18nBase('goal_amount_title', {
    maxGoalAmount: formattedMaxGoalAmount,
  })
}
class CrowdfundingBasics extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    untouchAll: PropTypes.func.isRequired,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    countryCode: PropTypes.string.isRequired,
    shouldAutoFocus: PropTypes.bool,
    formattedMaxGoalAmount: PropTypes.string,
    charity: PropTypes.object,
    disclaimer: PropTypes.string,
  }

  UNSAFE_componentWillMount = () => {
    this.props.untouchAll()
  }

  componentDidMount() {
    sendEnsightenEvent('MoneyPoolStart')
  }

  constructor(props) {
    super(props)
  }

  render() {
    const {
      anyInactiveFieldsTouchedWithError,
      disclaimer,
      fields: { poolName, goalAmount, endDate },
      formattedMaxGoalAmount,
      charity,
    } = this.props

    return (
      <form onSubmit={this.props.handleSubmit}>
        <HeadingText size="md" styleName="title">
          {i18n('title')}
        </HeadingText>
        <div>
          {this.props.charity && (
            <>
              <div styleName="charity-header">{i18n('charity_header')}</div>
              <CharityCard charity={charity} />
            </>
          )}
          <div styleName="textbox-wrapper">
            <TextBox
              title={i18nBase('pool_name_title')}
              dataNemo="your-pool-name"
              autoFocus={this.props.shouldAutoFocus}
              {...poolName}
            />
          </div>
          <div styleName="textbox-wrapper">
            <MoneyTextBox
              title={getGoalAmountTitle(charity, formattedMaxGoalAmount)}
              dataNemo="goal-amount"
              disableCents={false}
              {...goalAmount}
            />
          </div>
          <div styleName="textbox-wrapper">
            <DateInputBox
              title={i18nBase('end_date_title', {
                maxDays: CROWDFUNDING_CAMPAIGN_MAX_DAYS,
              })}
              dataNemo="date-pool-ends"
              {...endDate}
            />
          </div>
        </div>
        <div styleName="tip-wrapper">
          <TipBox text={i18n('tip_description')} />
        </div>
        {!charity && (
          <CaptionText
            dangerouslySetInnerHTML={{ __html: disclaimer }}
            styleName="gn-disclaimer"
          />
        )}
        <button
          data-nemo="create-basics-next"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          onClick={() =>
            trackEventNameClick({
              event_name: 'dw_giving_create_fundraiser_next_pressed',
              charity_name: charity && charity.name,
              npid: charity && charity.nonprofit_id,
            })
          }
        >
          {i18n('next')}
        </button>
      </form>
    )
  }
}

export default cssModules(CrowdfundingBasics, styles, { allowMultiple: true })
